<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">Редактировать информацию</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="page__row">
          <div class="page__item">
            <AppInput title="Название"
                      :value="department.name"
                      :valid="{}"
                      @value-changed="setNewName"
                      @keyup-enter="updateDepartment"
            />
          </div>
          <div class="page__item">
            <AppSelect :title="inputHeadTitle"
                       placeholder="Укажите руководителя"
                       :value="currentHead"
                       :options="userLeaderList"
                       :is-users="true"
                       @value-changed="setNewHead"
            />
          </div>
        </div>
        <div class="page__row">
          <div class="page__item">
            <AppTextarea title="ЦКП"
                         :value="department.ckp"
                         @value-changed="setNewCkp"
            />
          </div>
          <div class="page__item">
            <AppTextarea title="Обязанности"
                         :value="department.duties"
                         @value-changed="setNewDuties"
            />
          </div>
        </div>
        <div class="page__row" :class="department.type === 0 || department.type === 1 || department.type === 2 ? 'mb-40' : ''">
          <div class="page__item">
            <AppInput title="Ссылка на должностные инструкции"
                      :value="department.instruction"
                      :valid="{}"
                      @value-changed="setNewInstruction"
            />
          </div>
          <div class="page__item">
            <AppInput title="Ссылка на папку штатного сотрудника"
                      :value="department.folder"
                      :valid="{}"
                      @value-changed="setNewFolder"
            />
          </div>
        </div>
        <div class="page__row align-start mb-40" v-if="department.type !== 0 && department.type !== 1 && department.type !== 2">
          <div class="page__item">
            <AppSelectMultiple title="Выбрать сотрудников"
                               placeholder="Выберите сотрудников"
                               :value="currentStaff"
                               :options="users"
                               :is-users="true"
                               @add-item="addNewStaffUser"
                               @remove-item="removeNewStaffUser"
            />
          </div>
          <div class="page__item" v-if="department.type === 3">
            <AppColorPicker title="Цвет"
                            :value="department.color"
                            @value-changed="setNewColor"
            />
          </div>
        </div>
        <div class="modal__button-wrap">
          <div class="modal__button">
            <AppButton title="Сохранить" type="main" @click.native="updateDepartment"/>
          </div>
          <div class="modal__button">
            <AppButton title="Отмена" type="alt" @click.native="closeModal"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'
import AppInput from '../input/AppInput'
import AppSelect from '../input/AppSelect'
import AppSelectMultiple from '../input/AppSelectMultiple'
import AppTextarea from '@/components/page/input/AppTextarea'
import AppColorPicker from '@/components/page/input/AppColorPicker'

export default {
  name: 'department-update-modal',
  components: {
    AppColorPicker,
    AppTextarea,
    AppSelectMultiple,
    AppSelect,
    AppInput,
    AppButton
  },
  props: {
    department: Object
  },
  computed: {
    inputHeadTitle () {
      let title = 'Руководитель'
      switch (this.department.type) {
        case 0:
          title = 'Сотрудник'
          break
        case 1:
          title = 'Сотрудник'
          break
        case 2:
          title = 'Сотрудник'
          break
        default:
          break
      }
      return title
    },
    currentHead () {
      // если есть объект с руководителем отдела то берем значение поля id руководителя, бывает такое,
      // что id руководителя есть, но по факту такого пользователя не существует а объект руководителя null
      const headId = this.department.head_id
      const headName = this.department.head_id ? this.department.head.profile.full_name : 'Не назначен'
      return {
        id: headId,
        name: headName
      }
    },
    currentStaff () {
      return this.department.users
    },
    userLeaderList () {
      const userList = [...this.$store.getters['[dictionaries] usersList']]
      userList.unshift({
        id: null,
        name: 'Нет руководителя',
        avatar: 'no-avatar'
      })
      return userList
    },
    users () {
      return this.$store.getters['[dictionaries] usersList']
    }
  },
  methods: {
    loadOptions () {
      this.$store.dispatch('[dictionaries] getUserList')
    },
    updateDepartment () {
      this.$store.dispatch('updateDepartment')
    },
    closeModal () {
      this.$store.dispatch('closeUpdateDepartmentModal')
    },
    setNewName (value) {
      this.$store.dispatch('updateDepartmentName', value)
    },
    setNewHead (obj) {
      this.$store.dispatch('updateDepartmentHead', obj)
    },
    setNewCkp (text) {
      this.$store.dispatch('updateDepartmentCkp', text)
    },
    setNewDuties (text) {
      this.$store.dispatch('updateDepartmentDuties', text)
    },
    setNewInstruction (text) {
      this.$store.dispatch('updateDepartmentInstruction', text)
    },
    setNewFolder (text) {
      this.$store.dispatch('updateDepartmentFolder', text)
    },
    addNewStaffUser (user) {
      this.$store.dispatch('addDepartmentStaffUser', { id: user.id, name: user.name })
    },
    removeNewStaffUser (user) {
      this.$store.dispatch('removeDepartmentStaffUser', { id: user.id, name: user.name })
    },
    setNewColor (color) {
      this.$store.dispatch('updateDepartmentColor', color)
    }
  },
  mounted () {
    this.loadOptions()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  overflow: auto;
  align-items: flex-start;
  padding-top: 10vh;
}

.modal {
  max-width: 920px;

  &__text {
    text-align: center;
    color: $font_color_second;
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }

  &__button {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
